import type { KeyboardEvent, MouseEvent, ReactNode } from 'react';
import styled from 'styled-components';
import { Popover } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

type Props = {
  content: ReactNode;
  style?: React.CSSProperties;
};

const InfoPopoverButton = ({ content, style }: Props): ReactNode => {
  const contents = Array.isArray(content)
    ? content.map((item: ReactNode, index: number): ReactNode => {
        return <div key={index}>{item}</div>;
      })
    : content;

  return (
    <Popover content={contents} placement="right" trigger={['hover', 'focus']}>
      <IconWrapper
        style={style}
        onClick={(event: MouseEvent<HTMLButtonElement>): void => {
          event.stopPropagation();
        }}
        onKeyDown={(event: KeyboardEvent<HTMLButtonElement>): void => {
          if (event.key === 'Escape') {
            event.currentTarget.blur();
          }
        }}
      >
        <StyledInfoCircleFilled />
      </IconWrapper>
    </Popover>
  );
};

const IconWrapper = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  transform: translateY(-1px);
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: none;
  padding: 0;
  background-color: transparent;
`;

const StyledInfoCircleFilled = styled(InfoCircleFilled)`
  color: #aeaeae;
`;

export { InfoPopoverButton };
